import { DocumentationSection } from '@/hooks/useDocumentation';
import * as LucideIcons from 'lucide-react';
import { cn } from '@/lib/utils';

interface SectionTreeProps {
  sections: DocumentationSection[];
  selectedSectionId: string | null;
  onSelectSection: (sectionId: string) => void;
}

export function SectionTree({ sections, selectedSectionId, onSelectSection }: SectionTreeProps) {
  const renderSection = (section: DocumentationSection) => {
    const IconComponent = section.icon
      ? (LucideIcons[section.icon as keyof typeof LucideIcons] as React.ComponentType<{ className?: string }>)
      : null;

    return (
      <button
        key={section.id}
        onClick={() => onSelectSection(section.id)}
        className={cn(
          'w-full flex items-center gap-2 px-3 py-2 text-sm rounded-md transition-colors text-left',
          selectedSectionId === section.id
            ? 'bg-primary text-primary-foreground'
            : 'hover:bg-accent hover:text-accent-foreground'
        )}
      >
        {IconComponent && <IconComponent className="h-4 w-4 shrink-0" />}
        <span className="truncate">{section.title}</span>
      </button>
    );
  };

  return (
    <div className="space-y-1">
      {sections
        .filter((s) => !s.parent_section_id)
        .map((section) => renderSection(section))}
    </div>
  );
}
